import NoDataFound from "components/common/NoDataFound";
import React, { useState } from "react";
import { Col, ProgressBar } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const AgeRangeCard = ({ ageGroups }) => {
  const { t } = useTranslation();
  const [genderType, setGenderType] = useState(null); // null for All, 1 for Male, 2 for Female

  const genderTypes = [
    { key: null, label: t("All") },     // maps to gender === 'All'
    { key: 1, label: t("Male") },       // maps to gender === 'Male'
    { key: 2, label: t("Female") },     // maps to gender === 'Female'
  ];

  const getGenderString = (key) => {
    if (key === 1) return "Male";
    if (key === 2) return "Female";
    return "All";
  };

  const selectedGenderData = ageGroups?.find(
    (item) => item.gender === getGenderString(genderType)
  );

  return (
    <Col lg={4} className="pe-0">
      <div className="gender_common age_range_div">
        <div className="d-flex justify-content-between">
          <h2 className="fs_20 mb-2">{t("Age Range")}</h2>
          <div className="range_buttons">
            {genderTypes.map((type) => (
              <button
                key={type.key}
                className={`secondary_btn ${
                  genderType === type.key ? "active" : ""
                }`}
                onClick={() => setGenderType(type.key)}
              >
                {type.label}
              </button>
            ))}
          </div>
        </div>

        {selectedGenderData?.ageGroups?.length > 0 ? (
          selectedGenderData.ageGroups.map((range, index) => (
            <div className="g_between age_range_inner_section" key={index}>
              <h2 className="fs_14 text_black label">{range?.range || "-"}</h2>
              <div className="w-100">
                <ProgressBar
                  now={range?.percentage}
                  title={`${range?.count}`}
                />
              </div>
              <h2 className="fs_14 text_primary">{range?.percentage}%</h2>
            </div>
          ))
        ) : (
          <NoDataFound />
        )}
      </div>
    </Col>
  );
};

export default AgeRangeCard;
